import React from 'react';
import PropTypes from 'prop-types';
import AmplifyTable from '@amplify/amplify-table';
import SelectableTableRow from '../table/SelectableTableRow';
import { TABLE_MEASUREMENTS, COLUMN_WIDTH } from '../../constants/shared/ListTableConstants';
import { createDataTourStep } from '../../utils/shared/demoModeUtils';
import './ListTable.scss';

const ListTable = ({
    tableTitle,
    tableData,
    selectedItemId,
    onRowClick,
    isSortable,
    buildColumns,
    buildRows,
    measurements,
    onHeaderClick,
}) => (
    <div className="list-table-wrap" data-tour-step={`${createDataTourStep(tableTitle)}`}>
        <div className="list-table-wrap" />
        <AmplifyTable
            isSortable={isSortable}
            columns={buildColumns(tableTitle)}
            rows={buildRows(tableData)}
            onRowClick={onRowClick}
            measurements={measurements}
            classNames={{
                headerClassName: 'cell header',
                rowClassName: 'selectable-row',
            }}
            headerRenderer={({ label, sortDirection }) => {
                const handleHeaderClick = () => {
                    onHeaderClick(sortDirection);
                };

                return (
                    // eslint-disable-next-line jsx-a11y/no-static-element-interactions
                    <span onClick={handleHeaderClick}>
                        {label}
                        {isSortable && <i className="icon-amplify-sort" />}
                    </span>
                );
            }}
            rowRenderer={renderProps => (
                <SelectableTableRow
                    {...renderProps}
                    isSelected={selectedItemId === renderProps.rowData.id}
                />
            )}
        />
    </div>
);

ListTable.defaultProps = {
    tableTitle: 'Name',
    tableData: [],
    measurements: TABLE_MEASUREMENTS.DEFAULT,
    selectedItemId: null,
    onRowClick: () => {},
    onHeaderClick: () => {},
    isSortable: true,
    buildRows: data =>
        data.map(item => ({
            id: item,
            listTableColumn: item,
        })),
    buildColumns: column => [
        {
            dataKey: 'listTableColumn',
            label: <>{column}</>,
            width: COLUMN_WIDTH.FIRST_COLUMN,
            headerClassName: 'border-left-0',
        },
    ],
};

ListTable.propTypes = {
    tableTitle: PropTypes.string,
    tableData: PropTypes.array,
    selectedItemId: PropTypes.string,
    onRowClick: PropTypes.func,
    onHeaderClick: PropTypes.func,
    isSortable: PropTypes.bool,
    buildRows: PropTypes.func,
    buildColumns: PropTypes.func,
    measurements: PropTypes.object,
};

export default ListTable;
